import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CorpCustomerStatistics" }

import {searchFormConfig} from '@/views/main/wechatMgmt/corpCustomerStatistics/config/search.config'
import {contentTableConfig} from '@/views/main/wechatMgmt/corpCustomerStatistics/config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData} from '@/service/main/system'
import {useStore} from '@/store'
import {initEmptyParam} from '@/hooks/useInitParam'
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'CorpCustomerStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getCompanyList = async () => {
  let corpData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const corpItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )

  corpItem!.options = corpData.map((item: any) => {
    return {title: item.name, value: item.id}
  })
}
getCompanyList()

const queryParam = {
  month: dayjs().format('YYYY-MM')
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "corpCustomerStatistics",
      downFilename: "主体客户统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSortChange: handleSortChange
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})